import type { SearchAvailableParams } from "./types";

export const phoneNumberKeys = {
  all: ["PHONE_NUMBERS"] as const,
  lists: () => [...phoneNumberKeys.all, "LIST"] as const,
  aiAgentNumbers: () =>
    [...phoneNumberKeys.lists(), "AI_AGENT_NUMBERS"] as const,
  withRecipients: (ids: number[]) =>
    [...phoneNumberKeys.lists(), "WITH_RECIPIENTS", ids] as const,
  ringingUsers: (phoneNumberId: number) =>
    [...phoneNumberKeys.all, "RINGING_USERS", phoneNumberId] as const,
  searchAvailable: (params: SearchAvailableParams) =>
    [...phoneNumberKeys.all, "SEARCH_AVAILABLE", params] as const,
  propertyDefaults: () =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULTS"] as const,
  propertyDefault: (propertyId: number) =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULT", propertyId] as const,
  leasingAgents: () => ["LEASING_AGENTS"] as const
};

// CRM-1769 Bring your number.
export const portingKeys = {
  all: ["PHONE_NUMBER_PORTS"] as const,
  lists: () => [...portingKeys.all, "LIST"] as const,
  detail: (id: number) => [...portingKeys.all, "DETAIL", id] as const,
  // One batched check per list of numbers; each number's answer is also kept
  // under its own key so it is only ever sent once.
  checkList: (numbers: string[], resubmitOfNumberIds: number[]) =>
    [...portingKeys.all, "CHECK", numbers, resubmitOfNumberIds] as const,
  checkNumber: (digits: string, resubmitOfNumberIds: number[]) =>
    [...portingKeys.all, "CHECK_NUMBER", digits, resubmitOfNumberIds] as const,
  monthlyFee: () => [...portingKeys.all, "MONTHLY_FEE"] as const,
  businessAddress: () => [...portingKeys.all, "BUSINESS_ADDRESS"] as const
};
